export enum MZingTouchGestures {
    Tap = 'tap',
    Swipe = 'swipe'
}

export enum MZingGestureDirections {
    Left = 'left',
    Right = 'right',
    None = 'none'
}

export enum MZingTapInteractions {
    Click = 'click',
    Tap = 'tap'
}
